/* =============================================

  Custom JS added by synq-ps.co.jp

=============================================== */

(function () {
  var BADGE_WRAPPER_SELECTOR = ".product-tile__promo-badge-wrapper";
  var OUTLET_BADGE_CLASS = "product-tile__promo-badge--outlet";
  var IMAGE_SELECTOR = ".product-tile__image";

  // 商品名にこのキーワードを含む商品はセールバッジを非表示にする
  var HIDE_SALE_KEYWORD = "- nkc";
  var TILE_SELECTOR = ".product-tile";
  var TILE_SALE_BADGE_SELECTOR = ".product-tile__promo-badge--sale";
  var PDP_SALE_BADGE_SELECTOR = ".sale_banner_product";

  function appendOutletBadgeToProductTiles() {
    var images = document.querySelectorAll(IMAGE_SELECTOR);
    images.forEach(function (img) {
      var alt = (img.getAttribute("alt") || "").toLowerCase();
      if (!alt.includes("- outlet")) {
        return;
      }
      
      var imageLink = img.closest("a");
      if (!imageLink) {
        return;
      }

      var badgeWrapper = imageLink.nextElementSibling;
      if (!badgeWrapper || !badgeWrapper.matches(BADGE_WRAPPER_SELECTOR)) {
        badgeWrapper = imageLink.parentElement
          ? imageLink.parentElement.querySelector(BADGE_WRAPPER_SELECTOR)
          : null;
      }

      if (!badgeWrapper) {
        return;
      }

      if (badgeWrapper.querySelector("." + OUTLET_BADGE_CLASS)) {
        return;
      }

      badgeWrapper.insertAdjacentHTML(
        "afterbegin",
        '<div class="product-tile__promo-badge product-tile__promo-badge--outlet"><div class="product-tile__promo-badge-text">OUTLET</div></div>'
      );
    });
  }

  // 商品一覧・関連商品などのタイルで、商品名（画像alt）に対象キーワードを含む場合にセールバッジを非表示にする
  function hideSaleBadgeOnProductTiles() {
    var images = document.querySelectorAll(IMAGE_SELECTOR);
    images.forEach(function (img) {
      var alt = (img.getAttribute("alt") || "").toLowerCase();
      if (!alt.includes(HIDE_SALE_KEYWORD)) {
        return;
      }

      var tile = img.closest(TILE_SELECTOR);
      var scope = tile;
      if (!scope) {
        var imageLink = img.closest("a");
        scope = imageLink ? imageLink.parentElement : null;
      }
      if (!scope) {
        return;
      }

      scope.querySelectorAll(TILE_SALE_BADGE_SELECTOR).forEach(function (badge) {
        badge.style.display = "none";
      });
    });
  }

  // 商品詳細ページで、商品名（og:title）に対象キーワードを含む場合にセールバッジを非表示にする
  function hideSaleBadgeOnProductPage() {
    var saleBadges = document.querySelectorAll(PDP_SALE_BADGE_SELECTOR);
    if (!saleBadges.length) {
      return;
    }

    var ogTitle = document.querySelector('meta[property="og:title"]');
    var productName = (
      ogTitle ? ogTitle.getAttribute("content") || "" : document.title || ""
    ).toLowerCase();

    if (!productName.includes(HIDE_SALE_KEYWORD)) {
      return;
    }

    saleBadges.forEach(function (badge) {
      badge.style.display = "none";
    });
  }

  function startDomObserver() {
    if (!document.body) {
      return;
    }

    var observer = new MutationObserver(function (mutations) {
      var shouldRescan = mutations.some(function (mutation) {
        if (mutation.type === "attributes") {
          if (!(mutation.target instanceof Element)) {
            return false;
          }
          return mutation.target.matches(IMAGE_SELECTOR);
        }

        if (mutation.type === "childList" && mutation.addedNodes.length) {
          return Array.from(mutation.addedNodes).some(function (node) {
            if (!(node instanceof Element)) {
              return false;
            }

            return node.matches(IMAGE_SELECTOR) || !!node.querySelector(IMAGE_SELECTOR);
          });
        }

        return false;
      });

      if (shouldRescan) {
        appendOutletBadgeToProductTiles();
        hideSaleBadgeOnProductTiles();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["alt"]
    });
  }

  function initOutletBadge() {
    appendOutletBadgeToProductTiles();
    hideSaleBadgeOnProductTiles();
    hideSaleBadgeOnProductPage();
    startDomObserver();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initOutletBadge);
  } else {
    initOutletBadge();
  }
})();


/* =============================================
  文言変更
=============================================== */

(function () {
  // <p class="chakra-text"> のテキストを完全一致で書き換える（from → to）
  var LABEL_SELECTOR = "p.chakra-text";
  var LABEL_REPLACEMENTS = [
    { from: "お届け方法", to: "お届け方法の設定" },
    { from: "指定の住所に贈る", to: "指定の住所に送る" }
  ];

  function renameLabels() {
    var labels = document.querySelectorAll(LABEL_SELECTOR);
    labels.forEach(function (label) {
      var text = (label.textContent || "").trim();
      LABEL_REPLACEMENTS.forEach(function (replacement) {
        if (text === replacement.from) {
          label.textContent = replacement.to;
        }
      });
    });
  }

  function startLabelObserver() {
    if (!document.body) {
      return;
    }

    var observer = new MutationObserver(function (mutations) {
      var shouldRescan = mutations.some(function (mutation) {
        if (mutation.type !== "childList" || !mutation.addedNodes.length) {
          return false;
        }

        return Array.from(mutation.addedNodes).some(function (node) {
          if (!(node instanceof Element)) {
            return false;
          }

          return node.matches(LABEL_SELECTOR) || !!node.querySelector(LABEL_SELECTOR);
        });
      });

      if (shouldRescan) {
        renameLabels();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function initLabelRename() {
    renameLabels();
    startLabelObserver();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initLabelRename);
  } else {
    initLabelRename();
  }
})();



